// extracted by mini-css-extract-plugin
module.exports = {"identity":"PatientEdit_identity_1y5gH"};